import React from "react";
import styled from "styled-components";

const SkeletonWrapper = styled.div`
  .skeleton-card {
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
    border: 1px solid #f0f0f0;
    padding: 12px;

    .skeleton-image {
      width: 100%;
      height: 250px;
      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
      background-size: 200% 100%;
      animation: loading 1.5s infinite;
      border-radius: 6px;
      margin-bottom: 12px;

      @keyframes loading {
        0% {
          background-position: 200% 0;
        }
        100% {
          background-position: -200% 0;
        }
      }
    }

    .skeleton-title {
      height: 20px;
      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
      background-size: 200% 100%;
      animation: loading 1.5s infinite;
      border-radius: 4px;
      margin-bottom: 8px;
    }

    .skeleton-text {
      height: 16px;
      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
      background-size: 200% 100%;
      animation: loading 1.5s infinite;
      border-radius: 4px;
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }

      &.short {
        width: 60%;
      }
    }

    .skeleton-price {
      height: 24px;
      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
      background-size: 200% 100%;
      animation: loading 1.5s infinite;
      border-radius: 4px;
      margin-bottom: 12px;
      width: 40%;
    }

    .skeleton-button {
      height: 36px;
      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
      background-size: 200% 100%;
      animation: loading 1.5s infinite;
      border-radius: 4px;
    }
  }
`;

const ProductSkeleton = () => {
  return (
    <SkeletonWrapper>
      <div className="skeleton-card">
        <div className="skeleton-image" />
        <div className="skeleton-title" />
        <div className="skeleton-text short" />
        <div className="skeleton-price" />
        <div className="skeleton-button" />
      </div>
    </SkeletonWrapper>
  );
};

export default ProductSkeleton;
